module.exports = __webpack_public_path__ + "static/media/pf.a68f0f63.svg";